import React from 'react';
import { bool } from 'prop-types';
import { createPortal } from 'react-dom';

export default class ModalPortal extends React.Component {
  static displayName = 'ModalPortal';

  static propTypes = {
    disabled: bool,
  };

  constructor(props) {
    super(props);
    this.modalRoot = document.getElementById('root-modals');
    this.portalWrap = document.createElement('div');
  }

  componentDidMount() {
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.portalWrap);
    }
  }

  componentWillUnmount() {
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.portalWrap);
    }
  }

  render() {
    if (!this.props.disabled && this.modalRoot && this.portalWrap) {
      return createPortal(this.props.children, this.portalWrap);
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPortal.js